interface CheckboxProps {
  label: string;
  checked: boolean;
  onChange: () => void;
  disabled?: boolean;
  hidden?: boolean;
}

/* CHECKBOX */
export const Checkbox: React.FC<CheckboxProps> = ({
  label,
  checked,
  onChange,
  disabled = false,
  hidden = false,
}) => {
  if (hidden) {
    return null;
  }
  return (
    <label hidden={hidden} className="checkbox-item">
      <input
        type="checkbox"
        checked={checked}
        onChange={onChange}
        disabled={disabled}
      />
      {label}
    </label>
  );
};
